<template>
  <v-dialog
      v-model="visible"
      persistent
      scrollable
      width="1050"
  >
    <v-card>
      <v-card-title class="subheading">
        如果经费来源为个人名下科研项目、平台或团队，在此检索项目和经费卡并选择！
      </v-card-title>

      <v-divider></v-divider>

      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs10>
              <v-text-field
                  label="输入项目名称检索"
                  v-model="projName"
                  clearable
                  />
            </v-flex>

            <v-flex xs2>
              <v-btn color="primary" @click = "onProjCardSearch">检索</v-btn>
            </v-flex>

          </v-layout>
        </v-container>
      </v-card-text>

      <v-data-table
          :headers="headers"
          :items="projCardItems"
          :loading="projCardLoading"
          item-key="card.number"
          hide-actions
          v-model="selected"
      >
        <template slot="items" slot-scope="props">
          <td>
            <v-checkbox
                v-model="props.selected"
                primary
                hide-details
                @change="onSelect(props.item)"
            ></v-checkbox>
          </td>

          <td>
            {{ props.index + 1}}
          </td>

          <td>
            {{ props.item.name}}
          </td>

          <td>
            {{ props.item.type ? props.item.type.name : ''}}
          </td>

          <td>
            {{ props.item.card ? props.item.card.number : ''}}
          </td>

          <td>
            {{ props.item.cardyue ? props.item.cardyue.xmje : ''}}
          </td>

          <td style="white-space: nowrap;">
            {{ props.item.card ? props.item.card.name : ''}}
          </td>
        </template>
      </v-data-table>

      <v-card-actions>
        <v-spacer/>
        <v-btn flat color="primary" @click.native="$emit('input', false)">取消</v-btn>
        <v-btn color="primary" @click = "onSelectProj">确定</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
const projCardUri = '/api/proj/card/';
export default {
  name: "SelectProj",
  model: {
    prop: 'visible',
    event: 'input'
  },
  props: ['visible'],
  data() {
    return {
      projCardItems: [],
      projCardLoading: false,

      projName: '',
      selected: [],

      // 表头
      headers: [
        {text: '', align: 'left', sortable: false, value: 'dbid', width: "5%"},
        {text: '#', align: 'left', sortable: false, value: 'dbid', width: "5%"},
        {text: '项目名称', align: 'left', sortable: true, value: 'title',width: "40%"},
        {text: '项目类别', align: 'left', sortable: true, value: 'typename',width: "20%"},
        {text: '经费卡号', align: 'left', sortable: true, value: 'card', width: "10%"},
        {text: '卡余额', align: 'left', sortable: true, value: 'cardyue', width: "10%"},
        {text: '经费卡类型', align: 'left', sortable: true, value: 'cardtype', width: "10%"},
      ],
    }
  },

  watch: {
    visible() {
      this.onProjCardSearch()
    },
  },

  methods:{
    onProjCardSearch() {
      this.axios
          .get(projCardUri, {
            params: {
              limit: 25,
              name: this.projName.trim()
            }
          })
          .then(rsp => {
            this.projCardItems = rsp.data.items;
          })
    },

    onSelect(item) {
      // 确保只选中当前项
      this.selected = [item];
    },

    onSelectProj() {
      if (this.selected.length === 0) {
        // 可选：如果没有选中项，可以提示用户或直接关闭
        this.$emit('input', false); // 关闭对话框
        return;
      }

      // 传递选中的数据给父组件
      this.$emit('ok', this.selected[0]); // 假设只允许单选，取第一个
      this.$emit('input', false); // 关闭对话框
    },
  }
}
</script>

<style scoped>

</style>